import { Typography } from "@material-tailwind/react";
import React from "react";
import TrustspikeFooterLogo from "../assets/Logo/Logo Png.png";
import { useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white drop-shadow-md shadow-lg shadow-blue-gray-200 w-full mt-7">
      <div className="flex justify-between items-center py-4 !pl-[85px] !pr-7">
        <div className="h-1/12 w-1/12 cursor-pointer" onClick={() => navigate("/analytics-dashboard")}>
          <img src={TrustspikeFooterLogo} alt="footer-logo" />
        </div>
        <Typography variant="small" color="blue-gray" className="font-normal">
          © Copyright {currentYear} TrustSpike. All Rights Reserved.
        </Typography>
      </div>
    </footer>
  );
}

export default Footer;
